/* Product card behaviour: add to cart, buy now, plus the carousel rail.

   Progressive enhancement only. Without this file every card still renders,
   the whole card is still clickable via the stretched title link, Buy Now is a
   plain cart permalink that adds the item and forwards to checkout, and the
   rail is still swipeable because it is a native overflow container. Nothing
   here is required to shop. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function announce(msg) {
    var live = document.getElementById('dm-card-live');
    if (!live) {
      live = document.createElement('p');
      live.id = 'dm-card-live';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      document.body.appendChild(live);
    }
    live.textContent = msg;
  }

  function paintCount(n) {
    document.querySelectorAll('.dm-count').forEach(function (el) {
      el.textContent = n;
    });
  }

  function bumpCount(by) {
    var el = document.querySelector('.dm-count');
    var now = el ? parseInt(el.textContent, 10) : 0;
    if (isNaN(now)) now = 0;
    paintCount(now + by);
  }

  function syncCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); })
      .catch(function () { /* the optimistic number stands */ });
  }

  function addRequest(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart.');
        return res.d;
      });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    });
  }

  function addToCart(card, btn, idleLabel) {
    var id = card && card.dataset.variant;
    var err = card ? card.querySelector('[data-card-error]') : null;
    if (!id || btn.dataset.state === 'loading') return;

    btn.dataset.state = 'loading';
    btn.disabled = true;
    btn.innerHTML = '<span class="dm-card__spin"></span>Adding…';
    if (err) { err.hidden = true; err.textContent = ''; }

    addRequest(id)
      .then(function () {
        btn.dataset.state = 'success';
        btn.disabled = false;
        btn.textContent = '✓ Added';
        bumpCount(1);
        syncCount();
        announce('Added to cart.');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          btn.dataset.state = 'idle';
          btn.textContent = idleLabel;
        }, 700);
      })
      .catch(function (ex) {
        btn.dataset.state = 'idle';
        btn.disabled = false;
        btn.textContent = idleLabel;
        if (err) { err.textContent = ex.message; err.hidden = false; }
        announce(ex.message);
      });
  }

  /* ---- buy now ----
     Checks out THIS item only: empty the cart, then hand the browser the same
     cart permalink the link already points at, which adds the one variant and
     forwards straight to checkout. Without the clear, whatever was already in
     the cart would ride along into the order.

     ONE round trip, not two. The previous version awaited /cart/clear.js AND
     /cart/add.js before navigating, so the customer watched a spinner through
     two sequential calls; the permalink folds the add into the navigation that
     had to happen anyway.

     The element stays an <a> whose href IS that permalink, so a click landing
     before this script has downloaded still reaches checkout with the item -
     that bare href used to point at the cart page, which is exactly the "Buy
     Now just puts it in the cart" behaviour being fixed. The only thing JS
     adds is emptying the cart first, so the no-JS path degrades to "checkout
     including whatever else was in there" rather than to something broken.
     A failed clear must never block checkout - hence the same handler on both
     settle paths. */
  function buyNow(card, link) {
    var id = card && card.dataset.variant;
    if (!id || link.dataset.state === 'loading') return;

    link.dataset.state = 'loading';
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'One moment…';
    announce('Taking you to checkout.');

    var go = function () {
      window.location.assign('/cart/' + Number(id) + ':1?return_to=%2Fcheckout');
    };
    clearCart().then(go, go);
  }

  function onClick(e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      addToCart(add.closest('[data-card]'), add, 'Add to Cart');
      return;
    }
    var buy = e.target.closest('[data-buy]');
    if (buy) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      buyNow(buy.closest('[data-card]'), buy);
    }
  }

  function rail(root) {
    var track = root.querySelector('[data-rail]');
    if (!track) return;
    var nav = root.querySelector('[data-rail-nav]');
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    var dotsWrap = root.querySelector('[data-rail-dots]');
    var dots = [];

    var every = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;
    var held = false;
    var surrendered = false;

    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function pageCount() {
      if (!track.clientWidth) return 1;
      return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    }

    function step() {
      var c = track.firstElementChild;
      if (!c) return Math.round(track.clientWidth * 0.8);
      var gap = parseInt(window.getComputedStyle(track).columnGap, 10) || 16;
      return c.offsetWidth + gap;
    }

    function goPage(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    function buildDots() {
      if (!dotsWrap) return;
      var n = pageCount();
      if (n === dots.length) return;
      dotsWrap.textContent = '';
      dots = [];
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dm-rail__dot';
        b.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + n);
        b.addEventListener('click', (function (idx) {
          return function () { surrender(); goPage(idx); };
        })(i));
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }

    function syncDots() {
      if (!dots.length || !track.clientWidth) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i < 0) i = 0;
      if (i > dots.length - 1) i = dots.length - 1;
      dots.forEach(function (d, n) {
        if (n === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    function update() {
      var max = maxScroll();
      var scrollable = max > 4;
      if (nav) nav.hidden = !scrollable;
      if (dotsWrap) dotsWrap.hidden = !scrollable;
      if (!scrollable) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }

      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max - 2;
      if (prev) {
        if (atStart && document.activeElement === prev) track.focus({ preventScroll: true });
        prev.hidden = atStart;
      }
      if (next) {
        if (atEnd && document.activeElement === next) track.focus({ preventScroll: true });
        next.hidden = atEnd;
      }

      buildDots();
      syncDots();
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }

    function go(dir) {
      var max = maxScroll();
      var to = track.scrollLeft + dir * step();
      if (dir > 0 && track.scrollLeft >= max - 2) to = 0;
      else if (dir < 0 && track.scrollLeft <= 2) to = max;
      track.scrollTo({ left: to, behavior: reduce ? 'auto' : 'smooth' });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (!every || reduce || held || surrendered) return;
      stop();
      timer = setInterval(function () { if (maxScroll() > 4) go(1); }, every);
    }
    function surrender() { surrendered = true; stop(); }

    if (prev) prev.addEventListener('click', function () { surrender(); go(-1); });
    if (next) next.addEventListener('click', function () { surrender(); go(1); });

    track.addEventListener('pointerdown', surrender);
    track.addEventListener('wheel', surrender, { passive: true });
    track.addEventListener('scroll', onScroll, { passive: true });

    root.addEventListener('mouseenter', function () { held = true; stop(); });
    root.addEventListener('mouseleave', function () { held = false; start(); });
    root.addEventListener('focusin', function () { held = true; stop(); });
    root.addEventListener('focusout', function () { held = false; start(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);

    update();
    start();
  }

  function boot() {
    document.addEventListener('click', onClick);
    document.querySelectorAll('[data-rail-root]').forEach(rail);
    window.addEventListener('pageshow', function (e) { if (e.persisted) syncCount(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
